import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { CartOutlined } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type VStackProps } from '@pets-ui/VStack/VStack'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { formatPrice } from '@utils'
import { ImageProduct } from '../ImageProduct/ImageProduct'

const styles = stylex.create({
  title: {
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    minHeight: 40,
  },
  originalPrice: {
    textDecoration: 'line-through',
  },
  wrapper: {
    borderRadius: '0px 0px 4px 4px',
    borderBottomColor: colors.grey300,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderLeftColor: colors.grey300,
    borderLeftStyle: 'solid',
    borderLeftWidth: 1,
    borderRightColor: colors.grey300,
    borderRightStyle: 'solid',
    borderRightWidth: 1,
  },
})

export interface CartSpecialOfferProductListItemProps extends VStackProps {
  locale?: Intl.LocalesArgument
  productImgSrc?: string
  productTitle?: string
  currency?: string
  salePrices?: number[]
  onActionClick?: () => void
  productFrameUrl?: string
}

export const CartSpecialOfferProductListItem = (props: CartSpecialOfferProductListItemProps) => {
  const { productImgSrc, productTitle, salePrices = [], currency, onActionClick, productFrameUrl, ...rest } = props
  return (
    <VStack width={112} flexShrink={0} {...rest}>
      <ImageProduct
        src={productImgSrc}
        fallback={<Box backgroundColor={colors.grey200} width={112} height={112} />}
        alt={productTitle}
        borderRadius="4px 4px 0 0"
        width="100%"
        height={112}
        objectFit="cover"
        frameUrl={productFrameUrl}
      />
      <VStack gap={1} p={2} rootStyle={styles.wrapper}>
        <Text variant="body" rootStyle={styles.title}>{productTitle}</Text>
        <HStack justifyContent="space-between" alignItems="center" onClick={onActionClick} cursor="pointer">
          <VStack>
            <Text color={colors.grey800} variant="h5">
              {`${formatPrice(currency, salePrices[0])}`}
            </Text>
          </VStack>
          <div>
            <Button minWidth={0} width={36} height={36} variant="outlined" size="small" color="grey"><CartOutlined fontSize={20} /></Button>
          </div>
        </HStack>
      </VStack>
    </VStack>
  )
}
